import OvinDetails from "../components/OvinDetails";
import BovinDetails from "../components/BovinDetails";
import { moutonPng } from "../assets/images";

function MoutonDetails() {
  return (
    <div className="bg-gray-50">
      {/* Hero */}
      <div
        className="relative h-[18rem] bg-cover bg-center"
        style={{ backgroundImage: `url(${moutonPng})` }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative h-full flex items-center justify-center text-center px-4">
          <h1 className="text-3xl md:text-5xl font-bold text-white max-w-4xl">
            Conseils pratiques pour réussir l’élevage des moutons
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16 space-y-20">
        <OvinDetails />
        <BovinDetails />
      </div>
    </div>
  );
}

export default MoutonDetails;
